import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

/**
 * Map an imported asset to Brand and/or Product folders.
 * Same image can create 1 or 2 assetDetails rows.
 *
 * data example:
 * {
 *   fileId: 123,
 *   integerId: ...,
 *   brand: { brandName: 'Swasthe Brand', subCategoryId: 1 },
 *   product: { asin: 'B0XXXX', subCategoryId: 7 }
 * }
 */
function MapImportedAssetService(token, data) {
    return axios.post(`${CURRENT_API_URL}/assetgallery/MapImportedAsset`, data, {
        headers: {
            'Authorization': token,
        }
    }).then((res) => {
        return res.data;
    }).catch((error) => {
        console.log(error);
        notify.NotifyError("An error occurred while mapping the asset. Please try again.");
        return false;
    });
}

export default MapImportedAssetService;
